export enum ImageResolution {
  Low,
  Medium,
  High,
}
